import { render, staticRenderFns } from "./skilled_wolker.vue?vue&type=template&id=48240f10&"
import script from "./skilled_wolker.vue?vue&type=script&lang=js&"
export * from "./skilled_wolker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports